import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: mapGetters({
    loading: 'skiliko/users/isLoading'
  }),
  methods: mapActions({
    save: 'skiliko/users/save'
  })
}



// WEBPACK FOOTER //
// ./src/mixins/user.js